var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeminaSearchIcon = function SvgFeminaSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.885 14.837c2.334-2.324 2.334-6.093 0-8.417s-6.117-2.324-8.451 0-2.334 6.093 0 8.417 6.117 2.324 8.451 0m1.19-9.603a7.61 7.61 0 0 1 .556 10.171l.179.222q.242.3.514.571l1.521 1.515a7 7 0 0 0 .492.446L21 19.531l-.779.776-.696.693-1.106-1.37a7 7 0 0 0-.514-.571l-1.521-1.515a7 7 0 0 0-.492-.446l-.537-.443c-3.005 2.329-7.351 2.118-10.113-.633a7.61 7.61 0 0 1 0-10.788 7.68 7.68 0 0 1 10.832 0z"
  })));
};
export default SvgFeminaSearchIcon;